import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {  faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';

const ShowAnsweredStatics = ({staticItem}) => {
    return (
        <div className='col-md-3 text-center'>
            <div className="bg-dark  px-2 py-3  text-white">
                <h4 className='p-3'>
                {
                    staticItem.name
                }
                <FontAwesomeIcon className='ms-2' icon={faArrowCircleRight}></FontAwesomeIcon>
                </h4>
                <div>
                    <p className='my-1'>Total Quiz: {staticItem.totalQuiz}</p>
                    <p className='my-1'>Right Answer: {staticItem.right}</p>
                </div>
            </div>
        </div>
    );
};

export default ShowAnsweredStatics;